import { render } from "./form_v2.vue?vue&type=template&id=6af5a548&scoped=true"
import script from "./form_v2.vue?vue&type=script&lang=js"
export * from "./form_v2.vue?vue&type=script&lang=js"

import "./form_v2.vue?vue&type=style&index=0&id=6af5a548&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af5a548"]])

export default __exports__